import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'

import InputField from '@/components/neue/InputField.vue'

const CENTS_PER_DOLLAR = 100


export default {
  __name: 'AmountField',
  props: {
  modelValue: { type: Number, default: null },
  kind: { type: String, default: 'money' },
  name: { type: String, default: undefined },
  description: { type: String, default: undefined },
  prefix: { type: String, default: undefined },
  suffix: { type: String, default: undefined }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const number = (text, parser) => {
  const n = parser(text)
  return Number.isFinite(n) ? n : null
}

const KINDS = {
  money: {
    prefix: '$',
    restrict: 'monetary',
    parse: text => {
      const dollars = number(text, parseFloat)
      return dollars === null ? null : Math.round(dollars * CENTS_PER_DOLLAR)
    },
    format: cents => (cents / CENTS_PER_DOLLAR).toFixed(2)
  },
  percent: { suffix: '%', restrict: 'monetary', parse: text => number(text, parseFloat), format: String },
  integer: { restrict: 'integer', parse: text => number(text, value => parseInt(value, 10)), format: String }
}

const props = __props
const emit = __emit

const display = value => (value === null || value === undefined ? '' : KINDS[props.kind].format(value))

const text = ref(display(props.modelValue))

const onInput = value => {
  text.value = value
  emit('update:modelValue', KINDS[props.kind].parse(value))
}

watch(
  () => props.modelValue,
  value => {
    if (KINDS[props.kind].parse(text.value) !== (value ?? null)) text.value = display(value)
  }
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(InputField, {
    "model-value": text.value,
    name: __props.name,
    description: __props.description,
    prefix: __props.prefix ?? KINDS[__props.kind].prefix,
    suffix: __props.suffix ?? KINDS[__props.kind].suffix,
    restrict: KINDS[__props.kind].restrict,
    shrinkwrap: "",
    "onUpdate:modelValue": onInput
  }, null, 8, ["model-value", "name", "description", "prefix", "suffix", "restrict"]))
}
}

}